import React, { useEffect,useState} from "react";
import axios from "axios";
import { useNavigate, useLocation, json} from 'react-router-dom';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
  } from "@mui/material";

function ManageEmailDestination() {
  const [tokenNow, setTokenNow] = useState('');
  const navigate = useNavigate();
  const [error, setError] = useState("");

  const [openConfirm, setOpenConfirm] = useState(false);
  const [openInputSuccess, setOpenInputSuccess] = useState(false);
  const [openInputFail, setOpenInputFail] = useState(false);

  const [category, setCategory] = useState("");
  const [event, setEvent] = useState("");
  const [template, setTemplate] = useState("");
  const [templateNotes, setTemplateNotes] = useState("");
  const [emailDestinationExcludeByTemplateId, setEmailDestinationExcludeByTemplateId] = useState([]);
  const [emailDestinationFindByTemplateId, setEmailDestinationFindByTemplateId] = useState([]);        
  const [selectedEmailId, setSelectedEmailId] = useState('');

  const resource = "operation/manage-email-destination";

    useEffect(() => {
      const storedToken = localStorage.getItem('token');
   
        const checkSessionToken = async () => {
          try {
            const response = await fetch(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
                },
              }
            );
    
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
    
            // Parse response text as a boolean value
            const text = await response.text();
            const data = text === "true";
    
            if (data) {
            } else {
              window.alert("Session is invalid");
              navigate("/login");
            }
          } catch (error) {
            console.error("Fetch Error:", error.message);
            setError("Fetch Error: " + error.message);
          }
        };
    
        checkSessionToken();

        setTokenNow(storedToken);
        // defaultPage(storedToken);
      }, []);

      const location = useLocation();
      const searchParams = new URLSearchParams(location.search);

      const templateId = searchParams.get("templateId");

      useEffect(() => {
        getNotificationConfigurationByTemplateId(templateId);
        loadEmailDestinationExcludeByTemplateId(templateId);
        loadEmailDestinationFindByTemplateId(templateId);
      }, []);

        const loadEmailDestinationExcludeByTemplateId = async (templateId) => {
          const result = await axios.get(
            `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/email-destination-exclude-by-template-id?templateId=${templateId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            }
          );
          const data = result.data;
          console.log("data Exclude " + JSON.stringify(data))
          setEmailDestinationExcludeByTemplateId(data);
        };

      const loadEmailDestinationFindByTemplateId = async (templateId) => {
        try {     
          const result = await axios.get(`https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/email-destination-find-by-template-id?templateId=${templateId}`, {
              headers: {
                authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
              },
            });
          const data = result.data;

          console.log("data include " + JSON.stringify(data))
          setEmailDestinationFindByTemplateId(data);    
        } catch (error) {
          console.error("Error loading order list:", error);
        }
      };

      const getNotificationConfigurationByTemplateId = async (templateId) => {
          try {
            const response = await fetch(
              `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/notification-configuration-by-template-id?templateId=${templateId}`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
                },
              }
            );
      
            const data = await response.json();
            if (!response.ok) {
              setError(data.message || "Failed to fetch session token data");
              throw new Error(data.message || "Failed to fetch session token data");
            }
      
            setCategory(data[0].category);
            setEvent(data[0].event)
            setTemplate(data[0].template)
            setTemplateNotes(data[0].notes)
          } catch (error) {
            console.error("Error get notification-configuration-by-template-id:", error.message);
            setError("Error get notification-configuration-by-template-id: " + error.message);
          }
        };
    
        const handleAddEmail = () => {
          if (!selectedEmailId) return;

          // Cari email yang dipilih
          const selectedEmail = emailDestinationExcludeByTemplateId.find(
            (item) => item.notification_internal_email_destination_id.toString() === selectedEmailId
          );

          if (!selectedEmail) return;

          // Hapus dari emailDestinationExcludeByTemplateId
          setEmailDestinationExcludeByTemplateId((prev) =>
            prev.filter(
              (item) => item.notification_internal_email_destination_id.toString() !== selectedEmailId
            )
          );

          // Tambah ke emailById
          setEmailDestinationFindByTemplateId((prev) => [...prev, selectedEmail]);

          // Reset selected value
          setSelectedEmailId('');
        };
  
      const handleSubmit = async (event) => {
        console.log("S templateId " + templateId)
        console.log("S emailDestinationFindByTemplateId " + JSON.stringify(emailDestinationFindByTemplateId))

          event.preventDefault();
          
          const inputManageEmailDestination = {
              notificationInternalEmailTemplateId: templateId,
              selectedRows: emailDestinationFindByTemplateId
            }
      
            try {
              const response = await fetch(
                "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/operation/manage-email-destination",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: 'Basic eGNwOk50dGkyMDI0IQ==',
                  },
                  body: JSON.stringify(inputManageEmailDestination)
                }
              );
      
              const data = await response.json();
              const responseBody = JSON.parse(data.body);
              if (!response.ok) {
                setError(data.message || "Failed to submit form");
                throw new Error(data.message || "Failed to submit form");
              }
      
              const { message} = responseBody;
              if (message == "success") {
                setOpenConfirm(false)
                setOpenInputSuccess(true)
              } else {
                setOpenConfirm(false)
                setOpenInputFail(true)
              }
            } catch (error) {
              console.error("Submission Error:", error.message);
              setError("Submission Error: " + error.message);
            }
        };
      
        const handleClose = () => {
          setOpenConfirm(false);
          setOpenInputFail(false)
        };
      
        const handleConfirmation = async (event) => {
          event.preventDefault();

          const selectedCount = Object.keys(emailDestinationFindByTemplateId).length
          if(selectedCount > 10) {
            window.scrollTo(0, 0);
            setError("Maximum number of rows selected is 5");
            
            return;
          } else {
            setOpenConfirm(true);
          }
        };
      
        function inputSuccess(){
          navigate("/operation/notification-configuration-list")
        }

        const handleRemoveEmail = (id) => {
          // Cari email yang akan dihapus dari emailDestinationFindByTemplateId
          const removedEmail = emailDestinationFindByTemplateId.find(
            (item) => item.notification_internal_email_destination_id === id
          );

          if (!removedEmail) return;

          // Update state
          setEmailDestinationFindByTemplateId((prev) =>
            prev.filter((item) => item.notification_internal_email_destination_id !== id)
          );

          setEmailDestinationExcludeByTemplateId((prev) => [...prev, removedEmail]);
        };

      return (
        <div className="container-order-list">
          {/*<update-code */}
          <input type="hidden" name="token" value={tokenNow} /> {/* Hidden token field */}
            {/* update-code>*/}
            <h1>Cross Connect Manage Email Destination Form</h1>
                <div className="title-order-input">   
                    {error && <p className="error-message">{error}</p>}              
                </div>  
                
                <div className='title-terminataion-input'> 
                  <h5>Notification Configuration Information</h5>
                </div>
                  
              <div className="textbox-gray-operation">
                <label htmlFor="companyName">Category</label>
                <input type="text" placeholder={category} disabled />
              </div>
              <div className="textbox-gray-operation">
                <label htmlFor="companyName">Event</label>
                <input type="text" placeholder={event} disabled />
              </div>
              <div className="textbox-gray-operation">
                <label htmlFor="companyName">Email Template</label>
                <input type="text" placeholder={template} disabled />
              </div>
              <div className="textbox-gray-operation">
                <label htmlFor="companyName">Template Note</label>
                <textarea
                  placeholder={templateNotes}
                  style={{
                    backgroundColor: "lightgrey",
                    color: "black",
                    paddingLeft: "5px",
                    width: '40%',
                    height: '100px'
                  }}
                  disabled
                ></textarea>
              </div>

              <div className="textbox-order-list">
                <label htmlFor="comboBox">Select Email Destination</label>
                <select
                  id="comboBox"
                  name="options"
                  value={selectedEmailId}
                  onChange={(e) => setSelectedEmailId(e.target.value)}
                >
                  <option hidden>Select Email Destination</option>
                  {emailDestinationExcludeByTemplateId.map((item) => (
                    <option
                      key={item.notification_internal_email_destination_id}
                      value={item.notification_internal_email_destination_id}
                    >
                      {item.email}
                    </option>
                  ))}
                </select>
                <i
                  className="bi bi-plus-square-fill"
                  title="Add"
                  style={{ cursor: 'pointer', fontSize: '1.2rem', color: 'green', marginLeft: '10px' }}
                  onClick={handleAddEmail}
                />
              </div>
              {/* </form> */}
              
            <form onSubmit={handleConfirmation}> 
                <div className='title-terminataion-input'> 
                  <h5>Email Destination Selected</h5>
                </div>
                           
                <table className="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'30%'}}>Email Destination</th>
                        <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'50%'}}>Email Notes</th>
                        <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'15%'}}>Status</th>
                        <th scope="col" style={{backgroundColor: '#070f26', color: 'white', width:'5%'}}>Action</th>
                    </tr>
                    </thead>
                    {emailDestinationFindByTemplateId.map((email,index) => (
                        <tbody>
                        <tr key={email.notification_internal_email_destination_id}>
                        <td>{email.email}</td>                       
                        <td>{email.notes}</td>
                        <td>{email.status}</td>
                        <td>
                          <i
                            className="bi bi-trash-fill"
                            title="Remove"
                            style={{ cursor: 'pointer', color: 'red', fontSize: '1.1rem' }}
                            onClick={() =>
                              handleRemoveEmail(email.notification_internal_email_destination_id)
                            }
                          ></i>
                        </td>
                        </tr>
                    </tbody>
                        ))}          
                </table>
                <input
                    type="submit"
                    className="btn-submit-input-termination"
                    value="Submit"
                />
            </form> 

            <Dialog open={openConfirm}>
                <DialogTitle>{"Are you sure you want to submit Manage Email Destination?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Clicking "Yes" will input submit Manage Email Destination.
                        </DialogContentText>
                    </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        No
                    </Button>
                    <Button onClick={handleSubmit} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
                </Dialog> 
                <Dialog open={openInputSuccess}>
                  <DialogTitle>{"Manage Email Destination submitted successfully"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={inputSuccess} color="primary" autoFocus>
                        Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            <Dialog open={openInputFail}>
                <DialogTitle>{"Manage Email Destination submitted failed"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Ok
                </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ManageEmailDestination;
